import getters from "./getters";
import actions from "./actions";
import mutations from "./mutations";

const state = () => ({
  authx_app: {}
});

export default {
  state,
  getters,
  actions,
  mutations
};
